import GameLifeline from "../GameBoard/GameLifeline";
import AvatarOne from "../../assets/images/creategame/avatar-one.png";
import { useState, useEffect, useRef, useMemo } from "react";
import ReportQuestionModal from "../../components/Modal/ReportQuestionModal";
import LifelineConfirmModal from "../../components/Modal/LifelineConfirmModal";
import LifelineSuccessModal from "../../components/Modal/LifelineSuccessModal";
import Ra7El7lalModal from "../../components/Modal/Ra7El7lalModal";
import SpinStealModal from "../../components/Modal/SpinStealModal";
import SwitchCategoryModal from "../../components/Modal/SwitchCategoryModal";
import { useParams, useNavigate } from "react-router-dom";
import GameAnswerTimerClock from "./Answer/GameAnswerTimerClock";
import { TimerProvider, useTimer } from "./Answer/TimerContext";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateAnswerAPI,
  useLifelineAPI,
  add1000QuestionAPI,
  addMysteryWildcardQuestionAPI,
  getQrCodeTimerSettingsAPI,
} from "../../api/game";
import useToast from "../../hooks/useToast";
import Loader from "../../components/Loader/Loader";
import { useTranslation } from "react-i18next";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import GamePlayImg from "../../assets/images/game-board/game-play-2.png";
import SecondaryBtn from "../../components/button/SecondaryBtn";
import { getDefaultPortraitByGender, resolveCharacterUrlFromList } from "../../utils/charcter";
import { getCharacterListAPI } from "../../api/user";
import GameAnswerQuestionContent from "./Answer/GameAnswerQuestionContent";
import GameAnswerCorrectAnswerContent from "./Answer/GameAnswerCorrectAnswerContent";
import { useGameDetailsFromLayout } from "../../layouts/Game/GameDetailsContext";

// Lifeline interface for type safety
interface Lifeline {
  lifeline_id: {
    name: { en: string; ar: string };
    description: { en: string; ar: string };
    image: string;
    _id: string;
    slug: string;
  };
  is_used: boolean;
  _id: string;
}

interface UseLifelinePayload {
  lifeline_id: string | null;
  team_lifeline_id?: string | null;
  game_id?: string | null;
  question_id?: string | null;
  team_id?: string | null;
  opponent_team_id?: string | null;
  opponent_team_lifeline_id?: string | null;
  points?: number | null;
  category_id?: string | null;
}

function getLocalizedField(value: unknown, lang: string): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && !Array.isArray(value)) {
    const o = value as Record<string, string>;
    return String(o[lang] ?? o.en ?? o.ar ?? "");
  }
  return String(value);
}

const GameAnswerContent = () => {
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  const [isSkipLifelineAnswerReveal, setIsSkipLifelineAnswerReveal] = useState(false);
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [showPassModal, setShowPassModal] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [selectedParticipantIds, setSelectedParticipantIds] = useState<string[]>([]);
  const [selectedParticipants, setSelectedParticipants] = useState<string[]>([]); // For multi-select pass
  const [selectedTeamId, setSelectedTeamId] = useState<string | null>(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [optionImagePreviewUrl, setOptionImagePreviewUrl] = useState<string | null>(null);
  const [questionData, setQuestionData] = useState<any>(null);
  console.log("questionData", questionData);
  const [questionMetaData, setQuestionMetaData] = useState<any>(null); // Stores the full question object with _id
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  // Second chance: click timer to give other team(s) 20 seconds to answer (fixed duration, not question time_limit)
  const SECOND_CHANCE_SECONDS = 20;
  const [secondChanceKey, setSecondChanceKey] = useState(0);
  const [isSecondChanceExpired, setIsSecondChanceExpired] = useState(false);
  const [playerTimerPaused, setPlayerTimerPaused] = useState(false);

  // Track if any lifeline was used this round (only 1 per round allowed)
  const [isLifelineUsedThisRound, setIsLifelineUsedThisRound] = useState(false);

  // Lifeline modal state
  const [showLifelineModal, setShowLifelineModal] = useState(false);
  const [selectedLifeline, setSelectedLifeline] = useState<Lifeline | null>(null);
  const [selectedLifelineTeamId, setSelectedLifelineTeamId] = useState<string>("");
  const [selectedLifelineTeamName, setSelectedLifelineTeamName] = useState<string>("");
  const selectedLifelineRef = useRef<Lifeline | null>(null);
  const selectedLifelineTeamIdRef = useRef<string>("");
  const selectedLifelineTeamNameRef = useRef<string>("");
  const [isUsingLifeline, setIsUsingLifeline] = useState(false);

  // Lifeline success modal state
  const [showLifelineSuccessModal, setShowLifelineSuccessModal] = useState(false);
  const [usedLifeline, setUsedLifeline] = useState<Lifeline | null>(null);
  const [usedLifelineTeamName, setUsedLifelineTeamName] = useState<string>("");
  const [usedLifelineTeamId, setUsedLifelineTeamId] = useState<string>("");

  // 1000-point question data from API response
  const [question1000Data, setQuestion1000Data] = useState<any>(null);
  const [is1000PointLifelineUsed, setIs1000PointLifelineUsed] = useState(false);

  // Refs to store data for navigation (to avoid closure issues)
  const question1000Ref = useRef<any>(null);
  const teamIdRef = useRef<string>("");
  const teamNameRef = useRef<string>("");
  const lifelineId1000Ref = useRef<string>("");
  const teamLifelineId1000Ref = useRef<string>("");
  const lastQuestionIdRef = useRef<string | null>(null);
  // Snapshot of current_team_turn at question load — frozen until we navigate away
  const frozenCurrentTeamTurnRef = useRef<any>(null);
  const { t } = useTranslation();
  // Backfire lifeline state
  const [showBackfireTeamModal, setShowBackfireTeamModal] = useState(false);
  const [isBackfireLifelineUsed, setIsBackfireLifelineUsed] = useState(false);
  const backfireChallengerTeamRef = useRef<{ id: string; name: string }>({ id: "", name: "" });
  const backfireOpponentTeamRef = useRef<{ id: string; name: string }>({ id: "", name: "" });
  const backfireLifelineIdRef = useRef<string>("");
  const backfireTeamLifelineIdRef = useRef<string>("");

  // Switch/Mystery lifeline state
  const [mysteryQuestionData, setMysteryQuestionData] = useState<any>(null);
  const [isSwitchLifelineUsed, setIsSwitchLifelineUsed] = useState(false);
  const mysteryQuestionRef = useRef<any>(null);
  const mysteryTeamIdRef = useRef<string>("");
  const mysteryTeamNameRef = useRef<string>("");
  const mysteryLifelineIdRef = useRef<string>("");
  const mysteryTeamLifelineIdRef = useRef<string>("");

  // Ra7 El 7lal lifeline state
  const [showRa7El7lalModal, setShowRa7El7lalModal] = useState(false);
  const [isRa7El7lalLoading, setIsRa7El7lalLoading] = useState(false);
  const [isRa7El7lalLifelineUsed, setIsRa7El7lalLifelineUsed] = useState(false);
  const [lifelineSuccessMessage, setLifelineSuccessMessage] = useState<string>("");
  const ra7El7lalTeamIdRef = useRef<string>("");
  const ra7El7lalTeamNameRef = useRef<string>("");
  const ra7El7lalLifelineRef = useRef<Lifeline | null>(null);

  // Nuke lifeline state
  const [showNukeTeamModal, setShowNukeTeamModal] = useState(false);
  const [isNukeLifelineUsed, setIsNukeLifelineUsed] = useState(false);
  const nukeTeamIdRef = useRef<string>("");
  const nukeTeamNameRef = useRef<string>("");
  const nukeOpponentTeamRef = useRef<{ id: string; name: string }>({ id: "", name: "" });
  const nukeLifelineIdRef = useRef<string>("");
  const nukeTeamLifelineIdRef = useRef<string>("");

  // Spin Steal lifeline state
  const [showSpinStealModal, setShowSpinStealModal] = useState(false);
  const [isSpinStealLoading, setIsSpinStealLoading] = useState(false);
  const [isSpinStealLifelineUsed, setIsSpinStealLifelineUsed] = useState(false);
  const spinStealTeamIdRef = useRef<string>("");
  const spinStealTeamNameRef = useRef<string>("");
  const spinStealLifelineRef = useRef<Lifeline | null>(null);

  // Switch Category lifeline state
  const [showSwitchCategoryModal, setShowSwitchCategoryModal] = useState(false);
  const [isSwitchCategoryLoading, setIsSwitchCategoryLoading] = useState(false);
  const switchTeamIdRef = useRef<string>("");
  const switchTeamNameRef = useRef<string>("");
  const switchLifelineRef = useRef<Lifeline | null>(null);

  const { questionId, gameId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const currentLanguage = localStorage.getItem("i18nextLng") || "en";
  const baseUrl = import.meta.env.VITE_API_URL;
  const {
    elapsedSecondsRef,
    secondChanceSecondsRef,
    isSecondChanceActive,
    setIsSecondChanceActive,
  } = useTimer();

  // Clear elapsed timer when question changes (during render so remounted timer starts fresh)
  if (questionId !== lastQuestionIdRef.current) {
    lastQuestionIdRef.current = questionId ?? null;
    elapsedSecondsRef.current = 0;
  }

  const gameDetailsFromLayout = useGameDetailsFromLayout();
  const isAnswerRevealed = gameDetailsFromLayout?.isAnswerRevealed ?? false;
  const setIsAnswerRevealed = gameDetailsFromLayout?.setIsAnswerRevealed;
  const setIsLifelineUsedOnQuestion = gameDetailsFromLayout?.setIsLifelineUsedOnQuestion;
  const gameData = (gameDetailsFromLayout?.game ?? null) as any;

  useEffect(() => {
    if (gameData?.isLifelineUsedForCurrentRound) {
      setIsLifelineUsedThisRound(true);
      setIsLifelineUsedOnQuestion?.(true);
    }
  }, [gameData?.isLifelineUsedForCurrentRound, setIsLifelineUsedOnQuestion]);

  useEffect(() => {
    if (isLifelineUsedThisRound) {
      setIsLifelineUsedOnQuestion?.(true);
    }
  }, [isLifelineUsedThisRound, setIsLifelineUsedOnQuestion]);

  useEffect(() => {
    if (showCorrectAnswer) {
      setIsAnswerRevealed?.(true);
    }
  }, [showCorrectAnswer, setIsAnswerRevealed]);

  const teamData = gameData?.teams || [];
  const current_team_turn = gameData?.current_team_turn;

  const { data: qrTimerSettingsData } = useQuery({
    queryKey: ["qrCodeTimerSettings"],
    queryFn: getQrCodeTimerSettingsAPI,
    staleTime: 5 * 60 * 1000,
  });

  const qrTimerCap = useMemo(() => {
    const difficulty = questionData?.difficulty as "easy" | "medium" | "hard" | undefined;
    const settings = qrTimerSettingsData?.data;
    if (difficulty && settings?.[difficulty]) {
      return settings[difficulty];
    }
    return 60;
  }, [questionData?.difficulty, qrTimerSettingsData?.data]);

  // Find question data when game data is loaded
  useEffect(() => {
    if (gameData?.categories && questionId) {
      let foundQuestion = null;
      for (const category of gameData.categories) {
        const question = category.questions?.find((q: any) => q._id === questionId);
        if (question) {
          foundQuestion = {
            ...question,
            categoryName: category?.category_id?.name || category?.name,
            categoryId: category._id,
          };
          break;
        }
      }
      setQuestionMetaData(foundQuestion);
      setQuestionData(foundQuestion);
      setIsSkipLifelineAnswerReveal(false);
      elapsedSecondsRef.current = 0;
      setIsSecondChanceActive(false); // New question: show main timer, not 20s
      setIsSecondChanceExpired(false);
      setPlayerTimerPaused(false);
      secondChanceSecondsRef.current = SECOND_CHANCE_SECONDS;
      setOptionImagePreviewUrl(null);
      // Snapshot the current turn when the question first loads so that a
      // lifeline API refetch (e.g. free-pass) cannot flip the turn indicator
      // while the user is still on the answer screen.
      if (gameData?.current_team_turn) {
        frozenCurrentTeamTurnRef.current = gameData.current_team_turn;
      }
    }
  }, [gameData, questionId]);
  // Submit answer mutation
  const { mutate: submitAnswer } = useMutation({
    mutationFn: updateAnswerAPI,
    onSuccess: async (data) => {
      // useToast(data?.message || t("gameAnswer.answerSubmittedSuccessfully"), "success");
      // Await invalidation so fresh data (updated points) is in cache before navigating
      await queryClient.invalidateQueries({ queryKey: ["gameDetails", gameId] });

      // Close modal and reset states
      setShowAnswerModal(false);
      setSelectedParticipantIds([]);
      setSelectedTeamId(null);

      // Navigate back to game board
      navigate(`/game/${gameId}`);
    },
    onError: (error: any) => {
      useToast(error.message || t("gameAnswer.failedToSubmitAnswer"), "error");
      setIsSubmitting(false);

      // Close modal and reset states
      setShowAnswerModal(false);
      setSelectedParticipantIds([]);
      setSelectedTeamId(null);
    },
  });

  // Use lifeline mutation
  const { mutate: useLifeline } = useMutation({
    mutationFn: useLifelineAPI,
    onSuccess: (data) => {
      setIsLifelineUsedThisRound(true);
      useToast(data?.message || t("gameAnswer.lifelineUsedSuccessfully"), "success");
      // Invalidate game details to get fresh data
      queryClient.invalidateQueries({ queryKey: ["gameDetails", gameId] });
      // Store the used lifeline info for success modal
      setUsedLifeline(selectedLifelineRef.current);
      setUsedLifelineTeamName(selectedLifelineTeamNameRef.current);
      // Show success modal
      setSelectedLifeline(null);
      setSelectedLifelineTeamId("");
      setSelectedLifelineTeamName("");
      selectedLifelineRef.current = null;
      selectedLifelineTeamIdRef.current = "";
      selectedLifelineTeamNameRef.current = "";
      setIsUsingLifeline(false);
      setShowLifelineModal(false);
      // Show success celebration modal
      setShowLifelineSuccessModal(true);
    },
    onError: (error: any) => {
      useToast(error.message || t("gameAnswer.failedToUseLifeline"), "error");
      setIsUsingLifeline(false);
      setShowLifelineModal(false);
    },
  });

  const { mutate: add1000Question } = useMutation({
    mutationFn: add1000QuestionAPI,
    onSuccess: (data: any) => {
      useToast(data?.message || t("gameAnswer.1000QuestionAddedSuccessfully"), "success");
      // Invalidate game details to get fresh data
      queryClient.invalidateQueries({ queryKey: ["gameDetails", gameId] });
      // Store the 1000-point question from API response
      const questionFromResponse = data?.data;

      // Store in refs for navigation (avoids closure issues)
      question1000Ref.current = questionFromResponse;
      lifelineId1000Ref.current = data?.data?.lifeline_id;
      teamLifelineId1000Ref.current = selectedLifelineRef.current?._id || "";
      teamIdRef.current = selectedLifelineTeamIdRef.current;
      teamNameRef.current = selectedLifelineTeamNameRef.current;

      setQuestion1000Data(questionFromResponse);
      setIsLifelineUsedThisRound(true);
      // Mark this as 1000-point lifeline
      setIs1000PointLifelineUsed(true);
      // Store the used lifeline info for success modal
      setUsedLifeline(selectedLifelineRef.current);
      setUsedLifelineTeamName(selectedLifelineTeamNameRef.current);
      setUsedLifelineTeamId(selectedLifelineTeamIdRef.current);
      setSelectedLifeline(null);
      setSelectedLifelineTeamId("");
      setSelectedLifelineTeamName("");
      selectedLifelineRef.current = null;
      selectedLifelineTeamIdRef.current = "";
      selectedLifelineTeamNameRef.current = "";
      setIsUsingLifeline(false);
      setShowLifelineModal(false);
      // Show success celebration modal
      setShowLifelineSuccessModal(true);
    },
    onError: (error: any) => {
      useToast(error?.response?.data?.message || t("gameAnswer.failedToAdd1000Question"), "error");
      setIsUsingLifeline(false);
      setShowLifelineModal(false);
    },
  });

  // Switch/Mystery wildcard question mutation
  const { mutate: addMysteryQuestion } = useMutation({
    mutationFn: addMysteryWildcardQuestionAPI,
    onSuccess: (data: any) => {
      useToast(data?.message || t("gameAnswer.mysteryWildcardQuestionAddedSuccessfully"), "success");
      // Invalidate game details to get fresh data
      queryClient.invalidateQueries({ queryKey: ["gameDetails", gameId] });
      // Store the mystery question from API response
      const questionFromResponse = data?.data;

      // Store in refs for navigation (avoids closure issues)
      mysteryQuestionRef.current = questionFromResponse;
      mysteryLifelineIdRef.current = data?.data?.lifeline_id;
      mysteryTeamLifelineIdRef.current = selectedLifelineRef.current?._id || "";
      mysteryTeamIdRef.current = selectedLifelineTeamIdRef.current;
      mysteryTeamNameRef.current = selectedLifelineTeamNameRef.current;

      setMysteryQuestionData(questionFromResponse);
      setIsLifelineUsedThisRound(true);
      // Mark this as Switch lifeline
      setIsSwitchLifelineUsed(true);
      // Store the used lifeline info for success modal
      setUsedLifeline(selectedLifelineRef.current);
      setUsedLifelineTeamName(selectedLifelineTeamNameRef.current);
      setUsedLifelineTeamId(selectedLifelineTeamIdRef.current);
      setSelectedLifeline(null);
      setSelectedLifelineTeamId("");
      setSelectedLifelineTeamName("");
      selectedLifelineRef.current = null;
      selectedLifelineTeamIdRef.current = "";
      selectedLifelineTeamNameRef.current = "";
      setIsUsingLifeline(false);
      // Show success celebration modal
      setShowLifelineSuccessModal(true);
    },
    onError: (error: any) => {
      useToast(error?.response?.data?.message || t("gameAnswer.failedToAddMysteryWildcardQuestion"), "error");
      setIsUsingLifeline(false);
    },
  });

  const [participants, setParticipants] = useState<any[]>([]);

  // Handle answer click - when a team is selected
  const handleAnswerClick = (answer: string, teamId: string) => {
    const team = gameData?.teams?.find((t: any) => t._id === teamId);
    const teamParticipants = team?.participants || [];
    setParticipants(teamParticipants);
    setSelectedAnswer(answer);
    setSelectedTeamId(teamId);

    // Auto-select if only one participant in the team
    if (teamParticipants.length === 1) {
      setSelectedParticipantIds([teamParticipants[0]?.user_id?._id]);
    } else {
      setSelectedParticipantIds([]);
    }

    setShowAnswerModal(true);
  };
  // Handle participant selection - toggle multi-select
  const handleParticipantClick = (participantId: string) => {
    setSelectedParticipantIds((prev) =>
      prev.includes(participantId) ? prev.filter((id) => id !== participantId) : [...prev, participantId]
    );
  };

  // Confirm the answer selection and call API
  const handleConfirmAnswer = () => {
    if (!questionMetaData?.question_id || !selectedTeamId || !gameId) return;

    setIsSubmitting(true);

    // Call API to submit answer with team ID (participant selection optional)

    submitAnswer({
      game_id: gameId,
      question_id: questionMetaData?.question_id,
      user_id: selectedParticipantIds,
      team_id: selectedTeamId,
    });


  };

  // Handle timer expiration - submit with null participant
  const handleTimerExpired = () => {
    if (!questionMetaData?.question_id || !gameId || isTimerExpired) return;

    setIsTimerExpired(true);
    // setIsSubmitting(true);

    // Call API to submit answer with null (no one answered in time)
    // submitAnswer({
    //   game_id: gameId,
    //   question_id: questionMetaData?.question_id,
    //   user_id: null,
    // });
  };

  const handleNoneAnswered = () => {
    if (!questionMetaData?.question_id || !gameId) return;
    setIsSubmitting(true);
    // Call API to submit answer with null (no one answered in time)
    submitAnswer({
      game_id: gameId,
      question_id: questionMetaData?.question_id,
      team_id: null,
      user_id: null,
    });
  };

  const handleStartSecondChance = () => {
    setIsSecondChanceExpired(false);
    setPlayerTimerPaused(false);
    setIsSecondChanceActive(true);
    secondChanceSecondsRef.current = SECOND_CHANCE_SECONDS;
    setSecondChanceKey((k) => k + 1);
  };

  const handleSecondChanceTimeUp = () => {
    secondChanceSecondsRef.current = 0;
    setIsSecondChanceExpired(true);
  };

  const handleResumePlayerTimer = () => {
    setIsSecondChanceExpired(false);
    setIsSecondChanceActive(false);
    setPlayerTimerPaused(true);
  };

  const isMainTimerStopped = useMemo(
    () =>
      showCorrectAnswer ||
      showReportModal ||
      showLifelineModal ||
      showBackfireTeamModal ||
      showLifelineSuccessModal ||
      showRa7El7lalModal ||
      showNukeTeamModal ||
      showSpinStealModal ||
      showSwitchCategoryModal,
    [
      showCorrectAnswer,
      showReportModal,
      showLifelineModal,
      showBackfireTeamModal,
      showLifelineSuccessModal,
      showRa7El7lalModal,
      showNukeTeamModal,
      showSpinStealModal,
      showSwitchCategoryModal,
    ],
  );

  const getPreviewTimerSeconds = () => {
    if (isSecondChanceActive) {
      return isSecondChanceExpired ? 0 : secondChanceSecondsRef.current;
    }
    return elapsedSecondsRef.current;
  };

  // Get all participants from all teams for pass modal
  // const getAllParticipants = () => {
  //   const allParticipants: any[] = [];
  //   gameData?.teams?.forEach((team: any) => {
  //     team.participants?.forEach((participant: any) => {
  //       allParticipants.push({
  //         ...participant,
  //         teamName: team.team_name,
  //         teamId: team._id,
  //       });
  //     });
  //   });
  //   return allParticipants;
  // };

  // Toggle participant selection for pass
  const toggleParticipantSelection = (participantId: string) => {
    setSelectedParticipants((prev) =>
      prev.includes(participantId) ? prev.filter((id) => id !== participantId) : [...prev, participantId]
    );
  };

  // Handle lifeline click - open confirmation modal
  const handleLifelineClick = (lifeline: Lifeline, teamId: string, teamName: string) => {
    if (lifeline?.lifeline_id?.slug === "switch") {
      useToast(t("gameBoard.lifelineNotAvailableOnGameAnswer") || "This lifeline can be used on game board only", "info");
      return;
    }
    if (isLifelineUsedThisRound) {
      useToast(t("gameBoard.onlyOneLifelinePerRound"), "error");
      return;
    }
    setSelectedLifeline(lifeline);
    setSelectedLifelineTeamId(teamId);
    setSelectedLifelineTeamName(teamName);
    selectedLifelineRef.current = lifeline;
    selectedLifelineTeamIdRef.current = teamId;
    selectedLifelineTeamNameRef.current = teamName;
    setShowLifelineModal(true);
  };

  // Handle lifeline modal close
  const handleLifelineModalClose = () => {
    setShowLifelineModal(false);
    setSelectedLifeline(null);
    setSelectedLifelineTeamId("");
    setSelectedLifelineTeamName("");
    selectedLifelineRef.current = null;
    selectedLifelineTeamIdRef.current = "";
    selectedLifelineTeamNameRef.current = "";
    setIsUsingLifeline(false);
  };

  // Handle lifeline use - call API or open next lifeline modal directly
  const handleLifelineConfirm = (
    lifelineArg?: Lifeline,
    teamIdArg?: string,
    teamNameArg?: string
  ) => {
    const isValidLifeline = (item: any): item is Lifeline =>
      Boolean(item && typeof item === "object" && item.lifeline_id && !("nativeEvent" in item));

    const lifelineToUse = isValidLifeline(lifelineArg)
      ? lifelineArg
      : (selectedLifeline || selectedLifelineRef.current);
    const teamIdToUse =
      (typeof teamIdArg === "string" && teamIdArg ? teamIdArg : undefined) ??
      (selectedLifelineTeamId || selectedLifelineTeamIdRef.current);
    const teamNameToUse =
      (typeof teamNameArg === "string" && teamNameArg ? teamNameArg : undefined) ??
      (selectedLifelineTeamName || selectedLifelineTeamNameRef.current);

    if (!gameId || !lifelineToUse || !teamIdToUse || !lifelineToUse?.lifeline_id?._id) return;
    setIsUsingLifeline(true);
    let payload: UseLifelinePayload = {
      lifeline_id: lifelineToUse.lifeline_id._id,
      team_lifeline_id: lifelineToUse._id,
    };
    if (lifelineToUse?.lifeline_id?.slug === "free-pass") {
      payload = {
        ...payload,
        game_id: gameId,
        question_id: questionData?.question_id,
        team_id: teamIdToUse,
      };
      useLifeline(payload);
    } else if (lifelineToUse?.lifeline_id?.slug === "1000-point-answer") {
      payload = {
        ...payload,
        game_id: gameId,
        question_id: questionData?.question_id,
        team_id: teamIdToUse,
      };
      add1000Question(payload);
    } else if (lifelineToUse?.lifeline_id?.slug === "backfire") {
      // Store challenger team info in refs
      backfireChallengerTeamRef.current = {
        id: teamIdToUse,
        name: teamNameToUse || "",
      };
      backfireLifelineIdRef.current = lifelineToUse.lifeline_id._id;
      backfireTeamLifelineIdRef.current = lifelineToUse._id;

      // Get opponent teams (all teams except the challenger)
      const opponentTeams = gameData?.teams?.filter((team: any) => team._id !== teamIdToUse) || [];

      // If only 2 teams total (1 opponent), auto-select the opponent
      if (opponentTeams.length === 1) {
        const opponent = opponentTeams[0];
        backfireOpponentTeamRef.current = {
          id: opponent._id,
          name: opponent.team_name,
        };
        handleBackfireTeamSelect(opponent._id, opponent.team_name);
        setIsLifelineUsedThisRound(true);
        // Mark as Backfire lifeline used
        setIsBackfireLifelineUsed(true);
        // Store info for success modal
        setUsedLifeline(lifelineToUse);
        setUsedLifelineTeamName(teamNameToUse || "");
        setUsedLifelineTeamId(teamIdToUse);
        setShowLifelineModal(false);
        setIsUsingLifeline(false);
        setShowLifelineSuccessModal(true);
      } else {
        // More than 2 teams - show team selection modal
        setShowLifelineModal(false);
        setIsUsingLifeline(false);
        setShowBackfireTeamModal(true);
      }
    } else if (lifelineToUse?.lifeline_id?.slug === "switch") {
      // Store the team info in refs
      switchTeamIdRef.current = teamIdToUse;
      switchTeamNameRef.current = teamNameToUse || "";
      switchLifelineRef.current = lifelineToUse;
      setShowLifelineModal(false);
      setIsUsingLifeline(false);
      setShowSwitchCategoryModal(true);
    } else if (lifelineToUse?.lifeline_id?.slug === "ra7-el-7lal") {
      // Store the team info in refs
      ra7El7lalTeamIdRef.current = teamIdToUse;
      ra7El7lalTeamNameRef.current = teamNameToUse || "";
      ra7El7lalLifelineRef.current = lifelineToUse;
      setShowLifelineModal(false);
      setIsUsingLifeline(false);
      setShowRa7El7lalModal(true);
    } else if (lifelineToUse?.lifeline_id?.slug === "nuke") {
      // Store the team info in refs
      nukeTeamIdRef.current = teamIdToUse;
      nukeTeamNameRef.current = teamNameToUse || "";
      nukeLifelineIdRef.current = lifelineToUse.lifeline_id._id;
      nukeTeamLifelineIdRef.current = lifelineToUse._id;

      // Get opponent teams (all teams except the current team)
      const opponentTeams = gameData?.teams?.filter((team: any) => team._id !== teamIdToUse) || [];

      // If only 1 opponent, auto-select and call API directly
      if (opponentTeams.length === 1) {
        const opponent = opponentTeams[0];
        nukeOpponentTeamRef.current = {
          id: opponent._id,
          name: opponent.team_name,
        };
        // Call the API directly
        const nukePayload = {
          lifeline_id: lifelineToUse.lifeline_id._id,
          team_lifeline_id: lifelineToUse._id,
          game_id: gameId,
          team_id: teamIdToUse,
          opponent_team_id: opponent._id,
        };
        useLifeline(nukePayload, {
          onSuccess: (data) => {
            setIsLifelineUsedThisRound(true);
            setIsNukeLifelineUsed(true);
            setUsedLifeline(lifelineToUse);
            setUsedLifelineTeamName(teamNameToUse || "");
            setUsedLifelineTeamId(teamIdToUse);
            setLifelineSuccessMessage(t("nuke.nukeActivatedSuccessfully", { opponentTeamName: opponent.team_name }));
            setShowLifelineModal(false);
            setIsUsingLifeline(false);
            setShowLifelineSuccessModal(true);
          },
          onError: (error: any) => {
            setShowLifelineModal(false);
            setIsUsingLifeline(false);
          },
        });
      } else {
        // Multiple opponents - show team selection modal
        setShowLifelineModal(false);
        setIsUsingLifeline(false);
        setShowNukeTeamModal(true);
      }
    } else if (lifelineToUse?.lifeline_id?.slug === "spin-steal") {
      // Store the team info in refs
      spinStealTeamIdRef.current = teamIdToUse;
      spinStealTeamNameRef.current = teamNameToUse || "";
      spinStealLifelineRef.current = lifelineToUse;
      setShowLifelineModal(false);
      setIsUsingLifeline(false);
      setShowSpinStealModal(true);
    }
  };

  // Handle Backfire opponent team selection
  const handleBackfireTeamSelect = (opponentTeamId: string, opponentTeamName: string) => {
    backfireOpponentTeamRef.current = {
      id: opponentTeamId,
      name: opponentTeamName,
    };
    setIsLifelineUsedThisRound(true);
    // Mark as Backfire lifeline used
    setIsBackfireLifelineUsed(true);
    // Store info for success modal
    setUsedLifeline(selectedLifeline);
    setUsedLifelineTeamName(backfireChallengerTeamRef.current.name);
    setUsedLifelineTeamId(backfireChallengerTeamRef.current.id);
    // Close team selection modal and show success modal
    setShowBackfireTeamModal(false);
    setShowLifelineSuccessModal(true);
  };

  // Handle Backfire team modal close
  const handleBackfireTeamModalClose = () => {
    setShowBackfireTeamModal(false);
    backfireChallengerTeamRef.current = { id: "", name: "" };
    backfireLifelineIdRef.current = "";
    backfireTeamLifelineIdRef.current = "";
  };

  // Handle Ra7 El 7lal modal confirm
  const handleRa7El7lalConfirm = (opponentTeamId: string | null, points: number | null) => {
    if (!gameId || !ra7El7lalLifelineRef.current) return;

    setIsRa7El7lalLoading(true);

    const payload: UseLifelinePayload = {
      lifeline_id: ra7El7lalLifelineRef.current.lifeline_id._id,
      team_lifeline_id: ra7El7lalLifelineRef.current._id,
      game_id: gameId,
      question_id: questionData?.question_id,
      team_id: ra7El7lalTeamIdRef.current,
    };

    // If opponent team is selected, always deduct 500 points
    if (opponentTeamId) {
      payload.opponent_team_id = opponentTeamId;
      payload.points = 500;
    }


    // Determine the success message based on selection
    const getSuccessMessage = () => {
      if (opponentTeamId) {
        const opponentTeam = teamData?.find((t: any) => t._id === opponentTeamId);
        const opponentName = opponentTeam?.team_name || "opponent";
        return t("ra7El7lal.pointsDeducted", { points: 500, opponentName: opponentName });
      }
      return t("ra7El7lal.lifelineUsedButNoPointsDeducted");
    };

    useLifeline(payload, {
      onSuccess: (data) => {
        setIsLifelineUsedThisRound(true);
        // Mark Ra7 El 7lal lifeline as used (to prevent navigation in success close)
        setIsRa7El7lalLifelineUsed(true);
        // Set the appropriate success message
        setLifelineSuccessMessage(getSuccessMessage());
        // Store the used lifeline info for success modal
        setUsedLifeline(ra7El7lalLifelineRef.current);
        setUsedLifelineTeamName(ra7El7lalTeamNameRef.current);
        setUsedLifelineTeamId(ra7El7lalTeamIdRef.current);
        // Close Ra7 El 7lal modal
        setShowRa7El7lalModal(false);
        setIsRa7El7lalLoading(false);
        // Show success modal
        setShowLifelineSuccessModal(true);
      },
      onError: (error: any) => {
        setIsRa7El7lalLoading(false);
      },
    });
  };

  // Handle Ra7 El 7lal modal close
  const handleRa7El7lalModalClose = () => {
    setShowRa7El7lalModal(false);
    ra7El7lalTeamIdRef.current = "";
    ra7El7lalTeamNameRef.current = "";
    ra7El7lalLifelineRef.current = null;
  };

  // Handle Nuke opponent team selection
  const handleNukeTeamSelect = (opponentTeamId: string, opponentTeamName: string) => {
    nukeOpponentTeamRef.current = {
      id: opponentTeamId,
      name: opponentTeamName,
    };

    // Call the API
    const nukePayload = {
      lifeline_id: nukeLifelineIdRef.current,
      team_lifeline_id: nukeTeamLifelineIdRef.current,
      game_id: gameId,
      team_id: nukeTeamIdRef.current,
      opponent_team_id: opponentTeamId,
    };

    useLifeline(nukePayload, {
      onSuccess: (data) => {
        setIsLifelineUsedThisRound(true);
        setIsNukeLifelineUsed(true);
        setUsedLifeline(selectedLifeline);
        setUsedLifelineTeamName(nukeTeamNameRef.current);
        setUsedLifelineTeamId(nukeTeamIdRef.current);
        setLifelineSuccessMessage(t("nuke.nukeActivatedSuccessfully", { opponentTeamName: opponentTeamName }));
        setShowNukeTeamModal(false);
        setShowLifelineSuccessModal(true);
      },
      onError: (error: any) => {
      },
    });
  };

  // Handle Nuke team modal close
  const handleNukeTeamModalClose = () => {
    setShowNukeTeamModal(false);
    nukeTeamIdRef.current = "";
    nukeTeamNameRef.current = "";
    nukeLifelineIdRef.current = "";
    nukeTeamLifelineIdRef.current = "";
  };

  // Handle Spin Steal modal confirm
  const handleSpinStealConfirm = (opponentTeamId: string, opponentTeamLifelineInstanceId: string) => {
    if (!gameId || !spinStealLifelineRef.current) return;

    const opponentTeam = teamData?.find((t: any) => t._id === opponentTeamId);
    const stolenLifeline = opponentTeam?.lifelines?.find((l: Lifeline) => l._id === opponentTeamLifelineInstanceId);
    if (!stolenLifeline) return;

    setIsSpinStealLoading(true);

    const payload: UseLifelinePayload = {
      lifeline_id: spinStealLifelineRef.current.lifeline_id._id,
      team_lifeline_id: spinStealLifelineRef.current._id,
      game_id: gameId,
      question_id: questionData?.question_id,
      team_id: spinStealTeamIdRef.current,
      opponent_team_id: opponentTeamId,
      opponent_team_lifeline_id: opponentTeamLifelineInstanceId,
    };

    const opponentTeamName = opponentTeam?.team_name || "opponent";
    const stolenLifelineName =
      stolenLifeline?.lifeline_id?.name?.[t("language") === "ar" ? "ar" : "en"] ||
      stolenLifeline?.lifeline_id?.name?.en ||
      "lifeline";


    useLifeline(payload, {
      onSuccess: (data) => {
        setIsLifelineUsedThisRound(true);
        setIsSpinStealLifelineUsed(true);
        setLifelineSuccessMessage(
          t("spinSteal.lifelineStolenSuccessfully", {
            lifelineName: stolenLifelineName,
            opponentTeamName: opponentTeamName,
          }) || `Successfully stole ${stolenLifelineName} from ${opponentTeamName}`
        );
        setUsedLifeline(spinStealLifelineRef.current);
        setUsedLifelineTeamName(spinStealTeamNameRef.current);
        setUsedLifelineTeamId(spinStealTeamIdRef.current);
        setShowSpinStealModal(false);
        setIsSpinStealLoading(false);
        setShowLifelineSuccessModal(true);
      },
      onError: (error: any) => {
        setIsSpinStealLoading(false);
      },
    });
  };

  // Handle Spin Steal modal close
  const handleSpinStealModalClose = () => {
    setShowSpinStealModal(false);
    spinStealTeamIdRef.current = "";
    spinStealTeamNameRef.current = "";
    spinStealLifelineRef.current = null;
  };

  // Handle Switch Category modal confirm
  const handleSwitchCategoryConfirm = (selectedCategoryId: string) => {
    if (!gameId || !switchLifelineRef.current || !selectedCategoryId) return;

    setIsSwitchCategoryLoading(true);

    const payload: UseLifelinePayload = {
      lifeline_id: switchLifelineRef.current.lifeline_id._id,
      team_lifeline_id: switchLifelineRef.current._id,
      game_id: gameId,
      question_id: questionData?.question_id,
      team_id: switchTeamIdRef.current,
      category_id: selectedCategoryId,
    };

    const selectedCategory = gameData?.categories?.find((c: any) => c._id === selectedCategoryId);
    const currentLanguage = t("language") === "ar" ? "ar" : "en";
    const categoryName =
      selectedCategory?.category_id?.name?.[currentLanguage] ||
      selectedCategory?.category_id?.name?.en ||
      t("switchCategory.category") ||
      "category";

    useLifeline(payload, {
      onSuccess: () => {
        setIsLifelineUsedThisRound(true);
        setLifelineSuccessMessage(
          t("switchCategory.categorySwitchedSuccessfully", { categoryName }) || `Category switched to ${categoryName}`
        );
        setUsedLifeline(switchLifelineRef.current);
        setUsedLifelineTeamName(switchTeamNameRef.current);
        setUsedLifelineTeamId(switchTeamIdRef.current);
        setShowSwitchCategoryModal(false);
        setIsSwitchCategoryLoading(false);
        setShowLifelineSuccessModal(true);
      },
      onError: () => {
        setIsSwitchCategoryLoading(false);
      },
    });
  };

  // Handle Switch Category modal close
  const handleSwitchCategoryModalClose = () => {
    setShowSwitchCategoryModal(false);
    switchTeamIdRef.current = "";
    switchTeamNameRef.current = "";
    switchLifelineRef.current = null;
  };

  // Handle lifeline success modal close - redirect based on lifeline type
  const handleLifelineSuccessClose = () => {
    const usedLifelineSlug = usedLifeline?.lifeline_id?.slug;

    setShowLifelineSuccessModal(false);

    // Use refs for navigation data (more reliable than state)
    if (is1000PointLifelineUsed && question1000Ref.current) {
      // Navigate to 1000-point question page with the question data
      navigate(`/game/${gameId}/1000-question`, {
        state: {
          question: question1000Ref.current,
          teamId: teamIdRef.current,
          teamName: teamNameRef.current,
          lifelineId: lifelineId1000Ref.current,
          teamLifelineId: teamLifelineId1000Ref.current,
        },
      });
    } else if (isBackfireLifelineUsed) {
      // Navigate to Backfire answer page
      navigate(`/game/${gameId}/backfire-answer`, {
        state: {
          questionData: questionData,
          questionMetaData: questionMetaData,
          challengerTeam: backfireChallengerTeamRef.current,
          opponentTeam: backfireOpponentTeamRef.current,
          lifelineId: backfireLifelineIdRef.current,
          teamLifelineId: backfireTeamLifelineIdRef.current,
        },
      });
    } else if (isSwitchLifelineUsed) {
      // Switch Category: Stay on the answer screen, just close the modal
      // The category switch will be handled by the backend
      setIsSwitchLifelineUsed(false);
      switchTeamIdRef.current = "";
      switchTeamNameRef.current = "";
      switchLifelineRef.current = null;
    } else if (isRa7El7lalLifelineUsed) {
      // Ra7 El 7lal: Stay on the answer screen, just close the modal
      // Timer will resume automatically since showLifelineSuccessModal is now false
      // Reset Ra7 El 7lal specific state
      setIsRa7El7lalLifelineUsed(false);
      ra7El7lalTeamIdRef.current = "";
      ra7El7lalTeamNameRef.current = "";
      ra7El7lalLifelineRef.current = null;
    } else if (isNukeLifelineUsed) {
      // Nuke: Stay on the answer screen, just close the modal
      setIsNukeLifelineUsed(false);
      nukeTeamIdRef.current = "";
      nukeTeamNameRef.current = "";
      nukeLifelineIdRef.current = "";
      nukeOpponentTeamRef.current = { id: "", name: "" };
    } else if (isSpinStealLifelineUsed) {
      // Spin Steal: Stay on the answer screen, just close the modal
      setIsSpinStealLifelineUsed(false);
      spinStealTeamIdRef.current = "";
      spinStealTeamNameRef.current = "";
      spinStealLifelineRef.current = null;
    } else if (usedLifelineSlug === "free-pass") {
      // Skip lifeline: still reveal the answer after points are awarded
      setIsSkipLifelineAnswerReveal(true);
      setShowCorrectAnswer(true);
    } else {
      // Navigate to game board for other lifelines
      navigate(`/game/${gameId}`);
    }

    // Reset common states and refs
    setUsedLifeline(null);
    setUsedLifelineTeamName("");
    setUsedLifelineTeamId("");
    setLifelineSuccessMessage("");
    setQuestion1000Data(null);
    setIs1000PointLifelineUsed(false);
    setIsBackfireLifelineUsed(false);
    setIsSwitchLifelineUsed(false);
    setIsNukeLifelineUsed(false);
    setIsSpinStealLifelineUsed(false);
    setMysteryQuestionData(null);
    question1000Ref.current = null;
    teamIdRef.current = "";
    spinStealTeamIdRef.current = "";
    spinStealTeamNameRef.current = "";
    spinStealLifelineRef.current = null;
    teamNameRef.current = "";
    backfireChallengerTeamRef.current = { id: "", name: "" };
    backfireOpponentTeamRef.current = { id: "", name: "" };
    backfireLifelineIdRef.current = "";
    mysteryQuestionRef.current = null;
    mysteryTeamIdRef.current = "";
    mysteryTeamNameRef.current = "";
    mysteryLifelineIdRef.current = "";
    nukeTeamIdRef.current = "";
    nukeTeamNameRef.current = "";
    nukeOpponentTeamRef.current = { id: "", name: "" };
    nukeLifelineIdRef.current = "";
    switchTeamIdRef.current = "";
    switchTeamNameRef.current = "";
    switchLifelineRef.current = null;
  };

  const { data: portraitCharacterListData } = useQuery({
    queryKey: ["characterList", "portrait"],
    queryFn: () => getCharacterListAPI({ type: "portrait" }),
    staleTime: 1000 * 60 * 30,
  });
  const portraitCharacters = (portraitCharacterListData as any)?.data?.characters || [];

  // Show loading state
  if ((!gameData && !gameDetailsFromLayout?.hasResolved)) {
    return (
      <div className="flex justify-center items-center h-full min-h-[50vh] bg-primary-ivory">
        <Loader />
      </div>
    );
  }



  return (
    <>
      <div
        className="wrapper flex-1 flex flex-col sm:flex-row  bg-no-repeat xl:bg-size[100%_100%] bg-cover bg-bottom bg-primary-ivory px-6 gap-4"
      >
        <section className="w-full md:w-[80%] flex justify-center items-center relative flex-1">
          <div className="w-full h-full flex justify-center items-center 2xl:pb-[1.9vw] md:pb-6 pb-5 landscape:max-lg:pb-5">
            <div className="w-full mx-auto relative z-20 h-full 2xl:pt-[1vw] xl:pt-3 pt-2 flex flex-col">
              <button
                onClick={() => setShowReportModal(true)}
                className="col-span-2  text-light-vermilion    2xl:gap-[0.5vw] md:gap-2   xl:px-4 hidden sm:flex absolute -bottom-2 start-10  z-10 bg-[#FFFF]  p-1  border-black-300 h-8  2xl:text-[1.89vw]  lg:text-base/tight text-sm/tight landscape:max-lg:text-sm/tight  lg:py-3 md:py-2  skew-x-[-10deg]
2xl:border-[0.104vw] border-[1.5px] items-center 2xl:py-[0.5vw] xl:py-1.5 py-1 landscape:max-lg:py-0.5 2xl:px-[1.042vw] lg:px-4 md:px-3  px-2.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[1.5vw]/[1.5vw] xl:text-xl/tight text-md/tight font-bold cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] gap-4 2xl:h-[2.5vw] xl:h-8 md:h-8
                "
              >
                <span className="2xl:w-[1.2vw] xl:w-5 w-4 2xl:h-[1.2vw] xl:h-5 h-4">
                  <svg
                    className="w-full h-full"
                    width="26"
                    height="24"
                    viewBox="0 0 26 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_3457_147464)">
                      <path
                        d="M14.8728 22.75C17.5036 22.75 19.5804 22.75 21.1186 22.521C22.6805 22.2883 23.9475 21.7836 24.647 20.5488L24.7679 20.3165C25.3177 19.1463 25.0927 17.875 24.5308 16.5019C24.0833 15.4081 23.365 14.1147 22.4573 12.5644L21.4889 10.9272L19.2433 7.14127L19.1897 7.05013C17.9032 4.8811 16.8852 3.16549 15.9381 2.00065C14.9717 0.812175 13.9236 0 12.5418 0C11.1599 4.66667e-05 10.1118 0.812175 9.14544 2.00065C8.42528 2.88643 7.6636 4.09045 6.77451 5.57014L5.84026 7.14127L3.59466 10.9272L3.53884 11.0207C2.19875 13.2799 1.14133 15.0633 0.552674 16.5019C-0.0465261 17.9664 -0.262313 19.3151 0.436462 20.5488L0.574315 20.7722C1.29565 21.8457 2.50076 22.3029 3.96494 22.521C5.50313 22.75 7.57992 22.75 10.2107 22.75H14.8728ZM12.5418 14.2917C11.8975 14.2915 11.3751 13.7692 11.3751 13.125V7.875C11.3751 7.23072 11.8975 6.70841 12.5418 6.70833C13.186 6.70833 13.7085 7.23066 13.7085 7.875V13.125C13.7085 13.7693 13.186 14.2917 12.5418 14.2917ZM12.5418 18.3773C11.8975 18.3772 11.3751 17.8549 11.3751 17.2107V17.1992C11.3751 16.5549 11.8975 16.0327 12.5418 16.0326C13.186 16.0326 13.7085 16.5549 13.7085 17.1992V17.2107C13.7085 17.8549 13.186 18.3773 12.5418 18.3773Z"
                        fill="#FF6C6C"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_3457_147464"
                        x="0"
                        y="0"
                        width="25.884"
                        height="23.95"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dx="0.8" dy="1.2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.537255 0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 1 0"
                        />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3457_147464" />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_3457_147464"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </span>
                <span className="underline">{t("gameAnswer.report")}</span>
              </button>

              {/* Timer */}
              <div className="hidden sm:flex gap-3 absolute 2xl:top-3 xl:top-3 top-2 start-1/2 -translate-x-1/2 -translate-y-1/2 rtl:translate-x-1/2 z-10 ">
                <GameAnswerTimerClock
                  isSecondChanceActive={isSecondChanceActive}
                  isSecondChanceExpired={isSecondChanceExpired}
                  playerTimerPaused={playerTimerPaused}
                  secondChanceKey={secondChanceKey}
                  questionType={questionData?.question_type}
                  qrTimerCap={qrTimerCap}
                  isMainTimerStopped={isMainTimerStopped}
                  onStartSecondChance={handleStartSecondChance}
                  onSecondChanceTimeUp={handleSecondChanceTimeUp}
                  onResumePlayerTimer={handleResumePlayerTimer}
                  secondChanceSeconds={SECOND_CHANCE_SECONDS}
                  elapsedSecondsRef={elapsedSecondsRef}
                  secondChanceSecondsRef={secondChanceSecondsRef}
                />
              </div>

              <button
                className="w-fit skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px] border-black-300 2xl:h-[3vw] xl:h-10 md:h-8 h-6 bg-primary-orange items-center 2xl:py-[0.8vw] xl:py-1.5 py-1 landscape:max-lg:py-0.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[1.3375vw]/[1.04vw] xl:text-base/tight text-sm/tight font-bold text-white cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] px-2 landscape:max-lg:mb-4 hidden sm:flex gap-3 absolute 2xl:-top-3 -top-2 start-10 z-10"
                onClick={!showCorrectAnswer && handleStartSecondChance}
              >
                {t("gameAnswer.questionAnswered")}
              </button>

              {/* points */}
              <button className="hidden sm:flex bg-primary-orange  px-6 2xl:px-10 2xl:h-[3vw] xl:h-10 md:h-8 h-6 landscape:max-lg:h-7.5 w-fit items-center  absolute 2xl:-top-4 -top-2 end-10 z-10 skew-x-[-10deg]
2xl:border-[0.104vw] border-[1.5px] border-black-300  2xl:py-[0.5vw] xl:py-1.5 py-1 landscape:max-lg:py-0.5  2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[1.5vw]/[1.5vw] xl:text-xl/tight text-md/tight font-bold text-white cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] gap-4
              ">
                <div className="font-bold text-3xl 2xl:text-4xl mt-1 text-white">
                  {questionData?.difficulty === "easy"
                    ? "200"
                    : questionData?.difficulty === "medium"
                      ? "400"
                      : "600"}
                </div>
              </button>

              {/* view correct answer button  */}
              {!showCorrectAnswer && (
                <div className="flex justify-center gap-2  flex-wrap items-center absolute bottom-0  md:-bottom-2 -end-5 md:end-10 z-10">
                  <button
                    onClick={() => setShowCorrectAnswer(true)}
                    className="skew-x-[-10deg]
2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-primary-orange flex items-center 2xl:py-[0.5vw] xl:py-1.5 py-1 landscape:max-lg:py-0.5 2xl:px-[1.042vw] lg:px-4 md:px-3  px-2.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[1.5vw]/[1.5vw] xl:text-xl/tight text-md/tight font-bold text-white cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] gap-4"
                  >
                    <span className="skew-x-10">
                      {t("gameAnswer.viewCorrectAnswer")}
                    </span>
                  </button>
                </div>

              )}

              {/* mobile view */}
              <div className="flex sm:hidden my-3 justify-center gap-2  flex-wrap items-center">

                <button
                  onClick={() => setShowReportModal(true)}
                  className="col-span-2 cursor-pointer text-light-vermilion  justify-center items-center 2xl:gap-[0.5vw] md:gap-2 gap-1 2xl:px-[0.83vw] xl:px-4 md:px-3 px-2.5 flex sm:hidden z-10 bg-[#FFFF] rounded-md p-1 border border-black-300 h-8 font-bold 2xl:text-[1.89vw] xl:text-xl/tight lg:text-base/tight text-sm/tight landscape:max-lg:text-sm/tight 2xl:py-[1vw] xl:py-4 lg:py-4 md:py-3 py-1.5"
                >

                  <span className="2xl:w-[1.2vw] xl:w-5 w-4 2xl:h-[1.2vw] xl:h-5 h-4">
                    <svg
                      className="w-full h-full"
                      width="26"
                      height="24"
                      viewBox="0 0 26 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_3457_147464)">
                        <path
                          d="M14.8728 22.75C17.5036 22.75 19.5804 22.75 21.1186 22.521C22.6805 22.2883 23.9475 21.7836 24.647 20.5488L24.7679 20.3165C25.3177 19.1463 25.0927 17.875 24.5308 16.5019C24.0833 15.4081 23.365 14.1147 22.4573 12.5644L21.4889 10.9272L19.2433 7.14127L19.1897 7.05013C17.9032 4.8811 16.8852 3.16549 15.9381 2.00065C14.9717 0.812175 13.9236 0 12.5418 0C11.1599 4.66667e-05 10.1118 0.812175 9.14544 2.00065C8.42528 2.88643 7.6636 4.09045 6.77451 5.57014L5.84026 7.14127L3.59466 10.9272L3.53884 11.0207C2.19875 13.2799 1.14133 15.0633 0.552674 16.5019C-0.0465261 17.9664 -0.262313 19.3151 0.436462 20.5488L0.574315 20.7722C1.29565 21.8457 2.50076 22.3029 3.96494 22.521C5.50313 22.75 7.57992 22.75 10.2107 22.75H14.8728ZM12.5418 14.2917C11.8975 14.2915 11.3751 13.7692 11.3751 13.125V7.875C11.3751 7.23072 11.8975 6.70841 12.5418 6.70833C13.186 6.70833 13.7085 7.23066 13.7085 7.875V13.125C13.7085 13.7693 13.186 14.2917 12.5418 14.2917ZM12.5418 18.3773C11.8975 18.3772 11.3751 17.8549 11.3751 17.2107V17.1992C11.3751 16.5549 11.8975 16.0327 12.5418 16.0326C13.186 16.0326 13.7085 16.5549 13.7085 17.1992V17.2107C13.7085 17.8549 13.186 18.3773 12.5418 18.3773Z"
                          fill="#FF6C6C"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_3457_147464"
                          x="0"
                          y="0"
                          width="25.884"
                          height="23.95"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood floodOpacity="0" result="BackgroundImageFix" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="0.8" dy="1.2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.537255 0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 1 0"
                          />
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3457_147464" />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_3457_147464"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </span>
                  <span className="underline">{t("gameAnswer.report")}</span>
                </button>

                <GameAnswerTimerClock
                  isSecondChanceActive={isSecondChanceActive}
                  isSecondChanceExpired={isSecondChanceExpired}
                  playerTimerPaused={playerTimerPaused}
                  secondChanceKey={secondChanceKey}
                  questionType={questionData?.question_type}
                  qrTimerCap={qrTimerCap}
                  isMainTimerStopped={isMainTimerStopped}
                  onStartSecondChance={handleStartSecondChance}
                  onSecondChanceTimeUp={handleSecondChanceTimeUp}
                  onResumePlayerTimer={handleResumePlayerTimer}
                  secondChanceSeconds={SECOND_CHANCE_SECONDS}
                  elapsedSecondsRef={elapsedSecondsRef}
                  secondChanceSecondsRef={secondChanceSecondsRef}
                />


                <button
                  className="w-fit skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-primary-orange flex items-center 2xl:py-[0.5vw] xl:py-1.5 py-1 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[1.3375vw]/[1.04vw] xl:text-base/tight text-sm/tight font-bold text-white cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] px-1 landscape:max-lg:mb-4"
                  onClick={handleStartSecondChance}
                >
                  {t("gameAnswer.questionAnswered")}
                </button>

                {/* points */}
                {/* bg-[#97A4F2] */}
                <button className=" bg-primary-orange border border-black-300 rounded-md px-10 2xl:px-12 2xl:h-[3.229vw]  h-8 landscape:max-lg:h-7.5 w-fit items-center justify-center">
                  <div className="font-bold text-2xl 2xl:text-4xl text-white">
                    {questionData?.difficulty === "easy"
                      ? "200"
                      : questionData?.difficulty === "medium"
                        ? "400"
                        : "600"}
                  </div>
                </button>
              </div>



              {!showCorrectAnswer && (
                <GameAnswerQuestionContent
                  questionData={questionData}
                  currentLanguage={currentLanguage}
                  isSecondChanceActive={isSecondChanceActive}
                  getPreviewTimerSeconds={getPreviewTimerSeconds}
                  SECOND_CHANCE_SECONDS={SECOND_CHANCE_SECONDS}
                  setOptionImagePreviewUrl={setOptionImagePreviewUrl}
                  getLocalizedField={getLocalizedField}
                  t={t}
                />
              )}

              {showCorrectAnswer && (
                <GameAnswerCorrectAnswerContent
                  setShowCorrectAnswer={setShowCorrectAnswer}
                  setIsSecondChanceActive={setIsSecondChanceActive}
                  questionData={questionData}
                  currentLanguage={currentLanguage}
                  setOptionImagePreviewUrl={setOptionImagePreviewUrl}
                  getLocalizedField={getLocalizedField}
                  t={t}
                  isSkipLifelineAnswerReveal={isSkipLifelineAnswerReveal}
                  gameData={gameData}
                  handleAnswerClick={handleAnswerClick}
                  handleNoneAnswered={handleNoneAnswered}
                  onNavigateNextQuestion={() => navigate(`/game/${gameId}`)}
                />
              )}
            </div>
          </div>
        </section>

        <section className="game-bottom-banner h-auto lg:h-full flex items-center relative justify-center">
          <div className="w-full 2xl:max-w-[65vw] max-w-335 mx-auto relative z-10 flex flex-col 2xl:gap-[1.25vw] xl:gap-1 md:gap-3 gap-2.5">
            <div className="flex flex-row sm:flex-col flex-wrap justify-center 2xl:gap-[0.8vw] xl:gap-3 md:gap-2 gap-1.5">
              {teamData?.map((team: any) => (
                <div
                  key={team._id}
                  className="w-[48%] sm:w-full"
                >
                  <GameLifeline
                    team={team}
                    score={team.total_points}
                    lifelines={team.lifelines}
                    onLifelineClick={handleLifelineClick}
                    isCurrentTurn={(frozenCurrentTeamTurnRef.current ?? current_team_turn)?._id === team._id}
                    disableAllLifelines={isLifelineUsedThisRound || gameData?.isLifelineUsedForCurrentRound}
                    disabledLifelineSlugs={isAnswerRevealed ? ["backfire"] : []}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Answer Modal */}
        {showAnswerModal && (
          <>
            <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
              <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] xl:p-10 md:p-7 p-4 relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] scroll-width-small">
                <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full 2xl:mb-[1vw] md:mb-4 mb-3">
                  <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/6 text-2xl/5 font-semibold text-primary-orange">
                    {t("gameAnswer.selectParticipant")}
                  </h1>
                  {/* Close Button */}
                  <button
                    onClick={() => {
                      setShowAnswerModal(false);
                      setSelectedParticipantIds([]);
                    }}
                    className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300"
                  >
                    <svg
                      className="w-full h-full"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                        fill="#333938"
                      />
                    </svg>
                  </button>
                </div>

                <div className="w-full 2xl:mb-[1.042vw] mb-5">
                  <svg
                    className="w-full"
                    width="540"
                    height="1"
                    viewBox="0 0 540 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      y1="-0.5"
                      x2="540"
                      y2="-0.5"
                      transform="matrix(-1 0 0 1 540 1)"
                      stroke="url(#paint0_linear_517_717)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_517_717"
                        x1="0"
                        y1="0.5"
                        x2="540"
                        y2="0.5"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#0B3369" stopOpacity="0" />
                        <stop offset="0.5" stopColor="#7364FF" />
                        <stop offset="1" stopColor="#0B3369" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                {/* Participant List with Multi Selection */}
                <div className="grid grid-cols-2 gap-2 2xl:gap-[0.833vw] md:gap-4 border-2 border-black-300 bg-primary-ivory 2xl:p-[1vw] p-4 2xl:rounded-[0.833vw] rounded-xl">
                  {participants.map((participant) => {
                    const participantId = participant?.user_id?._id;
                    const isSelected = selectedParticipantIds.includes(participantId);
                    const participantPortrait =
                      resolveCharacterUrlFromList(participant?.user_id?.profile_image, portraitCharacters) ||
                      getDefaultPortraitByGender(
                        participant?.user_id?.gender || participant?.gender,
                        portraitCharacters
                      ) ||
                      null;
                    return (
                      <button
                        key={participant._id}
                        onClick={() => handleParticipantClick(participantId)}
                        className={`cursor-pointer w-full min-w-0 flex items-center 2xl:gap-[0.6vw] gap-2`}
                      >
                        <div
                          className="2xl:w-[2.5vw] xl:w-[40px] lg:w-10 w-10 2xl:min-w-[2.5vw] xl:min-w-[40px] lg:min-w-10 min-w-10 2xl:h-[2.5vw] xl:h-[40px] lg:h-10 h-10 aspect-square overflow-hidden
                              bg-primary-light-orange skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:rounded-[0.26vw] rounded-[5px] 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] flex justify-center items-center"
                        >
                          {participantPortrait ? (
                            <img
                              src={participantPortrait}
                              alt={participant?.user_id?.full_name}
                              className="w-full h-full object-cover"
                            />
                          ) : <span className="text-center text-xl">
                            {participant?.user_id?.full_name?.charAt(0)?.toUpperCase() || "?"}
                          </span>}
                        </div>
                        <div
                          className={`min-w-0 flex-1 skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] border-black-300 flex items-center 2xl:py-[0.54vw] py-1.5 2xl:px-[1.042vw] lg:px-4 md:px-3  px-2.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[0.9375vw]/[1.04vw] text-sm/tight md:text-base/tight font-bold cursor-pointer justify-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
                        ${isSelected ? "bg-primary-orange text-white" : "bg-[#F2BF7D] text-black-300"}`}
                        >
                          <span className={`skew-x-[10deg] 2xl:mt-[0.208vw] mt-1 text-start w-full break-words`}>
                            {participant?.user_id?.full_name}
                          </span>
                        </div>
                      </button>
                    );
                  })}
                </div>
                {/* Confirm Button */}
                <PrimaryBtn isLoading={isSubmitting} onClick={handleConfirmAnswer} className="!mb-0 w-full min-w-full 2xl:mt-[1vw] mt-4">
                  {t("gameAnswer.confirmAnswer")}
                </PrimaryBtn>
              </div>
            </div>
            <style>{`
                @keyframes slideUp {
                  from {
                    opacity: 0;
                    transform: translateY(20px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}</style>
          </>
        )}
        {showReportModal && (
          <ReportQuestionModal
            isOpen={showReportModal}
            onClose={() => setShowReportModal(false)}
            questionData={questionData}
            quistionIdToReport={questionData?.question_id}
          />
        )}

      </div>


      {/* Lifeline Confirmation Modal */}
      <LifelineConfirmModal
        isOpen={showLifelineModal}
        lifeline={selectedLifeline}
        teamName={selectedLifelineTeamName}
        onConfirm={() => handleLifelineConfirm()}
        onClose={handleLifelineModalClose}
        isLoading={isUsingLifeline}
      />

      {/* Lifeline Success Modal */}
      <LifelineSuccessModal
        isOpen={showLifelineSuccessModal}
        lifeline={usedLifeline}
        teamName={usedLifelineTeamName}
        onClose={handleLifelineSuccessClose}
        autoCloseDelay={3000}
        customMessage={lifelineSuccessMessage || undefined}
      />

      {/* Ra7 El 7lal Modal */}
      <Ra7El7lalModal
        isOpen={showRa7El7lalModal}
        lifeline={ra7El7lalLifelineRef.current}
        teamId={ra7El7lalTeamIdRef.current}
        teamName={ra7El7lalTeamNameRef.current}
        teams={teamData || []}
        onConfirm={handleRa7El7lalConfirm}
        onClose={handleRa7El7lalModalClose}
        isLoading={isRa7El7lalLoading}
      />

      {/* Spin Steal Modal */}
      <SpinStealModal
        isOpen={showSpinStealModal}
        lifeline={spinStealLifelineRef.current}
        teamId={spinStealTeamIdRef.current}
        teamName={spinStealTeamNameRef.current}
        teams={teamData || []}
        onConfirm={handleSpinStealConfirm}
        onClose={handleSpinStealModalClose}
        isLoading={isSpinStealLoading}
      />

      {/* Switch Category Modal */}
      <SwitchCategoryModal
        isOpen={showSwitchCategoryModal}
        lifeline={switchLifelineRef.current}
        teamId={switchTeamIdRef.current}
        teamName={switchTeamNameRef.current}
        categories={gameData?.categories || []}
        onConfirm={handleSwitchCategoryConfirm}
        onClose={handleSwitchCategoryModalClose}
        isLoading={isSwitchCategoryLoading}
      />

      {/* Backfire Team Selection Modal */}
      {showBackfireTeamModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
          <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] xl:p-10 md:p-7 p-4 2xl:max-w-[28vw] max-w-[540px] 2xl:shadow-[0px_0px_3.854vw_0px_#C3DC78CC_inset] shadow-[0px_0px_74px_0px_#C3DC78CC_inset] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)]">
            <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full 2xl:mb-[1vw] md:mb-4 mb-3">
              <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/6 text-2xl/5 font-semibold text-primary-orange">
                {t("gameAnswer.challengeATeam")}
              </h1>
              <button
                onClick={handleBackfireTeamModalClose}
                className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300"
              >
                <svg className="w-full h-full" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                    fill="#333938"
                  />
                </svg>
              </button>
            </div>

            <div className="w-full 2xl:mb-[1.042vw] mb-5">
              <svg className="w-full" width="540" height="1" viewBox="0 0 540 1" fill="none">
                <line
                  y1="-0.5"
                  x2="540"
                  y2="-0.5"
                  transform="matrix(-1 0 0 1 540 1)"
                  stroke="url(#paint0_linear_backfire)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_backfire"
                    x1="0"
                    y1="0.5"
                    x2="540"
                    y2="0.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#0B3369" stopOpacity="0" />
                    <stop offset="0.5" stopColor="#7364FF" />
                    <stop offset="1" stopColor="#0B3369" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            {/* Challenger Info */}
            <div className="text-center 2xl:mb-[1vw] mb-4 border-2 border-black-300 bg-primary-ivory 2xl:p-[1vw] p-4 2xl:rounded-[0.833vw] rounded-xl">
              <p className="text-black-300 text-xl">
                <span className="font-bold text-primary-orange">{backfireChallengerTeamRef.current.name}</span>{" "}
                {t("gameAnswer.isUsingBackfire")}
              </p>
              {/* <p className="2xl:text-[1vw] text-base font-semibold text-primary-violet">
                {t("gameAnswer.backfireDescription")} {backfireChallengerTeamRef.current.name}{" "}
                {t("gameAnswer.getsThemPoints")}
              </p> */}
            </div>

            {/* Opponent Team Selection */}
            <div className="2xl:space-y-[0.833vw] md:space-y-4 space-y-3">
              <p className="2xl:text-[1vw] text-base font-bold text-black-300 text-center">
                {t("gameAnswer.selectOpponentTeam")}
              </p>
              {gameData?.teams
                ?.filter((team: any) => team._id !== backfireChallengerTeamRef.current.id)
                .map((team: any) => (
                  <button
                    key={team._id}
                    onClick={() => handleBackfireTeamSelect(team._id, team.team_name)}
                    className="cursor-pointer w-full skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[#E7E6E6] flex items-center justify-center 2xl:py-[0.5vw] xl:py-1 py-1 2xl:px-[1.042vw] lg:px-4 md:px-3 px-2.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[0.9375vw]/[1.04vw] xl:text-base/tight text-sm/tight font-bold text-black-300 text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] hover:bg-primary-orange hover:text-white transition-colors"
                  >
                    <span className="skew-x-10 2xl:mt-[0.208vw] mt-1">{team.team_name}</span>
                  </button>
                ))}
            </div>
          </div>
          <style>{`
              @keyframes slideUp {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
              }
            `}</style>
        </div>
      )}

      {/* Nuke Team Selection Modal */}
      {showNukeTeamModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
          <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] xl:p-10 md:p-7 p-4 2xl:max-w-[28vw] max-w-[540px] 2xl:shadow-[0px_0px_3.854vw_0px_#C3DC78CC_inset] shadow-[0px_0px_74px_0px_#C3DC78CC_inset] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)]">
            <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full 2xl:mb-[1vw] md:mb-4 mb-3">
              <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/6 text-2xl/5 font-semibold text-primary-orange">
                {t("gameAnswer.launchNuke")}
              </h1>
              <button
                onClick={handleNukeTeamModalClose}
                className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300"
              >
                <svg className="w-full h-full" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                    fill="#333938"
                  />
                </svg>
              </button>
            </div>

            <div className="w-full 2xl:mb-[1.042vw] mb-5">
              <svg className="w-full" width="540" height="1" viewBox="0 0 540 1" fill="none">
                <line
                  y1="-0.5"
                  x2="540"
                  y2="-0.5"
                  transform="matrix(-1 0 0 1 540 1)"
                  stroke="url(#paint0_linear_nuke)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_nuke"
                    x1="0"
                    y1="0.5"
                    x2="540"
                    y2="0.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#0B3369" stopOpacity="0" />
                    <stop offset="0.5" stopColor="#7364FF" />
                    <stop offset="1" stopColor="#0B3369" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            {/* Nuke Info */}
            <div className="text-center 2xl:mb-[1vw] mb-4">
              <p className="2xl:text-[0.85vw] text-sm text-gray-600 mb-2">
                <span className="font-semibold text-primary-orange">{nukeTeamNameRef.current}</span>{" "}
                {t("gameAnswer.isLaunchingNuke")}
              </p>
              <p className="2xl:text-[0.8vw] text-sm text-gray-700">{t("gameAnswer.selectWhichTeamToTarget")}</p>
            </div>

            {/* Opponent Team Selection */}
            <div className="2xl:space-y-[0.833vw] md:space-y-4 space-y-3">
              <p className="2xl:text-[1vw] text-base font-semibold text-black-300 text-center">
                {t("gameAnswer.selectTargetTeam")}
              </p>
              {gameData?.teams
                ?.filter((team: any) => team._id !== nukeTeamIdRef.current)
                .map((team: any) => (
                  <button
                    key={team._id}
                    onClick={() => handleNukeTeamSelect(team._id, team.team_name)}
                    className="cursor-pointer w-full flex items-center justify-center 2xl:gap-[0.417vw] gap-2 2xl:py-[0.8vw] py-3 2xl:px-[1vw] px-4 rounded-full transition-all duration-300 bg-purple-fill 2xl:border-[0.26vw] border-5 border-transparent [background:padding-box_linear-gradient(#C0C0C0,#E9E9E9),border-box_linear-gradient(#E9E9E9,#B3B5B4)] hover:[background:padding-box_linear-gradient(#EF4444,#DC2626),border-box_linear-gradient(#DC2626,#EF4444)] hover:text-white text-black-300 2xl:text-[1vw] text-lg font-medium"
                  >
                    {team.team_name}
                  </button>
                ))}
            </div>
          </div>
          <style>{`
              @keyframes slideUp {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
              }
            `}</style>
        </div>
      )}

      {/* Pass Modal - Multi-select participants */}
      {showPassModal && (
        <>
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
            <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] xl:p-10 md:p-7 p-4 2xl:max-w-[28vw] max-w-[540px] 2xl:shadow-[0px_0px_3.854vw_0px_#C3DC78CC_inset] shadow-[0px_0px_74px_0px_#C3DC78CC_inset] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)]">
              <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full 2xl:mb-[1vw] md:mb-4 mb-3">
                <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/6 text-2xl/5 font-semibold text-primary-orange">
                  {t("gameAnswer.passQuestion")}
                </h1>
                {/* Close Button */}
                <button
                  onClick={() => {
                    setShowPassModal(false);
                    setSelectedParticipants([]);
                  }}
                  className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300"
                >
                  <svg
                    className="w-full h-full"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                      fill="#333938"
                    />
                  </svg>
                </button>
              </div>

              <div className="w-full 2xl:mb-[0.8vw] mb-4">
                <svg
                  className="w-full"
                  width="540"
                  height="1"
                  viewBox="0 0 540 1"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    y1="-0.5"
                    x2="540"
                    y2="-0.5"
                    transform="matrix(-1 0 0 1 540 1)"
                    stroke="url(#paint0_linear_pass)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_pass"
                      x1="0"
                      y1="0.5"
                      x2="540"
                      y2="0.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#0B3369" stopOpacity="0" />
                      <stop offset="0.5" stopColor="#7364FF" />
                      <stop offset="1" stopColor="#0B3369" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <p className="2xl:text-[0.85vw] text-sm text-black-400 2xl:mb-[1vw] mb-4 text-center">
                {t("gameAnswer.selectParticipantsWhoAnsweredIncorrectly")}
              </p>

              {/* Participant List with Multi Selection by Team */}
              <div className="2xl:space-y-[1vw] space-y-4 max-h-[50vh] overflow-y-auto hide-scroll">
                {gameData?.teams?.map((team: any) => (
                  <div key={team._id}>
                    <h3 className="2xl:text-[0.9vw] text-base font-semibold text-primary-orange 2xl:mb-[0.5vw] mb-2">
                      {team.team_name}
                    </h3>
                    <div className="2xl:space-y-[0.5vw] space-y-2">
                      {team.participants?.map((participant: any) => {
                        const participantId = participant?.user_id?._id;
                        const isSelected = selectedParticipants.includes(participantId);
                        return (
                          <button
                            key={participant._id}
                            onClick={() => toggleParticipantSelection(participantId)}
                            className={`cursor-pointer w-full flex items-center 2xl:gap-[0.417vw] gap-2 2xl:py-[0.208vw] 2xl:ps-[0.417vw] py-1 ps-2 pe-4 rounded-full transition-all duration-300 ${isSelected
                              ? "bg-purple-fill 2xl:border-[0.26vw] border-5 border-transparent [background:padding-box_linear-gradient(#453C99,#7364FF),border-box_linear-gradient(#7364FF,#453C99)]"
                              : "bg-purple-fill 2xl:border-[0.26vw] border-5 border-transparent [background:padding-box_linear-gradient(#C0C0C0,#E9E9E9),border-box_linear-gradient(#E9E9E9,#B3B5B4)]"
                              }`}
                          >
                            <img
                              src={participant?.user_id?.profile_image || AvatarOne}
                              alt={participant.full_name}
                              className="2xl:w-[2.292vw] 2xl:h-[2.292vw] md:w-11 w-9 md:h-11 h-9 rounded-full object-cover bg-purple-fill 2xl:border-[0.156vw] border-3 border-transparent [background:padding-box_linear-gradient(#C0C0C0,#E9E9E9),border-box_linear-gradient(#E9E9E9,#B3B5B4)]"
                            />
                            <span
                              className={`2xl:text-[0.938vw] text-lg font-medium flex-1 text-start ${isSelected ? "text-white" : "text-black-300"
                                }`}
                            >
                              {participant.full_name}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>


            </div>
          </div>
          <style>{`
              @keyframes slideUp {
                from {
                  opacity: 0;
                  transform: translateY(20px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            `}</style>
        </>
      )}

      {optionImagePreviewUrl && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-60 p-4"
          onClick={() => setOptionImagePreviewUrl(null)}
          role="presentation"
        >
          <div
            className="relative max-w-[min(90vw,720px)] max-h-[min(85dvh,720px)] p-2 bg-white-500 rounded-xl border-[1.5px] border-black-300 shadow-lg"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button
              type="button"
              onClick={() => setOptionImagePreviewUrl(null)}
              className="absolute -top-2 -end-2 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-primary-yellow border-[1.5px] border-black-300 shadow-[0px_2px_0px_#110706] hover:scale-105 transition-transform"
              aria-label="Close"
            >
              <span className="text-black-300 font-bold leading-none text-lg">×</span>
            </button>
            <img
              src={optionImagePreviewUrl}
              alt=""
              className="max-w-full max-h-[min(80dvh,680px)] w-auto h-auto object-contain mx-auto block rounded-md"
            />
          </div>
        </div>
      )}
    </>

  );
};

const GameAnswer = () => (
  <TimerProvider>
    <GameAnswerContent />
  </TimerProvider>
);

export default GameAnswer;
